module.exports = __webpack_public_path__ + "static/media/nft1.6a79af6d.png";